/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { Task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import { VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT } from 'cio/services/event-bus';

interface EditActionSidebarBaseDeleteButtonArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  deleteTask: Task<unknown, []>;
  isSaving: boolean;
  onDeleteStarted: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class EditActionSidebarBaseDeleteButton extends Component<EditActionSidebarBaseDeleteButtonArgs> {
  @service auth!: AuthService;

  VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT = VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT;

  get disableDueRedactedAuthorEditingWebhook() {
    return this.auth.redacted && this.args.actionAbstract.action.info.shortName === 'webhook';
  }
}
